export const guess_getBond_success = 'guess_getBond_success';//去竞猜
export const guess_getBond_show = 'guess_getBond_show';//是否展示购买入场卷成功
export const guess_juanbao_count = 'guess_juanbao_count';//卷包数量
export const metaRecovery24_0116 = 'metaRecovery24_0116';//元素合成的actycode
export const unity_noty_pay_result = 'unity_noty_pay_result';//元宇宙支付结果
